<template>
	<div class="station-pin-container">
		<div class="station-pin-wrapper">
			<div class="station-pin-content" :class="{temporaryDisable: disabled}">
				<p class="station-name">{{ userStore.user.name }}</p>
				<BottomNumberEditorNumpad ref="numpad" class="numpad" @change-number="changeNumber" :starting-number="0" no-actions no-last-row />
				<div class="bottom-row">
					<div class="numpad-screen-container"><div class="numpad-screen">{{ numpadScreen }}</div></div>
					<div class="btn-delete" :class="{disabled: currentNumber === 0}" @click="cancel()"><div class="btn-inner">C</div></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BottomNumberEditorNumpad from "@/console-new/components/ops/counter/BottomNumberEditorNumpad.vue";
import {useUserStore} from "@/console-new/stores";
import {playLockSound, playUnlockSound} from "@/console-new/helpers/sound";

export default {
	setup() {
		let userStore = useUserStore();
		return {userStore};
	},
	name: "StationPin",
	components: {BottomNumberEditorNumpad},
	data() {
		return {
			currentNumber: 0,
			disabled: false,
			soundLock: null,
			soundUnlock: null
		}
	},
	computed: {
		numpadScreen() {
			if(this.disabled) {
				return 'ERROR';
			} else {
				if(this.currentNumber > 0) {
					return '#'.repeat((this.currentNumber+"").length);
				} else {
					return '';
				}
			}
		}
	},
	methods: {
		changeNumber(number) {
			this.currentNumber = number;
			let found = false;
			if(this.userStore.businessUsers && Object.keys(this.userStore.businessUsers).length > 0) {
				Object.values(this.userStore.businessUsers).forEach(user => {
					if(user.code && user.code === this.currentNumber+"") {
						this.unlock(user.user_id);
						found = true;
					}
				});
			}
			if(!found && (this.currentNumber+"").length >= 6) {
				this.wrongCode();
				playLockSound();
			}
		},
		wrongCode() {
			this.cancel();
			this.disabled = true;
			setTimeout(() => {
				this.disabled = false;
			}, 1000);
		},
		cancel() {
			this.$refs.numpad.cancel();
		},
		unlock(userId) {
			playUnlockSound();
			this.userStore.unlockUserId = userId;
			this.userStore.addLockChecker();
		}
	},
	mounted() {
		if(!this.userStore.businessUsers || Object.keys(this.userStore.businessUsers).length === 0) {
			this.userStore.getBusinessUsers();
		}
	}
}
</script>

<style scoped lang="scss">
.station-pin-container {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 13;
	background-color: rgba(5, 44, 90, 0.58);
	-webkit-backdrop-filter: blur(5px);
	backdrop-filter: blur(5px);
	display: flex;
	justify-content: center;

	.station-pin-wrapper {
		overflow-y: auto;
		padding: 20px 0;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;

		.station-pin-content {
			background-color: var(--color-bg);
			padding: 20px;
			border-radius: 13px;
			width: fit-content;
			margin: auto;

			.station-name {
				font-size: 16px;
				font-weight: 500;
				text-align: center;
				margin-bottom: 15px;
			}

			.bottom-row {
				display: flex;
				align-items: stretch;
				margin-top: 10px;
				gap: 10px;

				.numpad-screen-container {
					flex-grow: 1;
					display: flex;
					align-items: center;

					.numpad-screen {
						background-color: #0752A366;
						border-radius: 13px;
						box-shadow: inset 0 1px 2px var(--color-alpha-4);
						display: flex;
						align-items: center;
						justify-content: flex-end;
						min-height: 60px;
						font-size: 38px;
						font-weight: 500;
						padding: 4px 12px;
						color: var(--color-txt-white);
						overflow: hidden;
						height: 70%;
						width: 100%;
					}

				}

				.btn-delete {
					flex-shrink: 0;
					background-color: #FC2291;
					color: var(--color-bg);
					border-radius: 26px;
					width: 80px;
					height: 80px;
					display: flex;
					justify-content: center;
					align-items: center;
					cursor: pointer;
					transition: opacity 0.2s ease-in-out;

					.btn-inner {
						background-color: var(--color-danger);
						font-size: 36px;
						border-radius: 20px;
						box-shadow: -3px -3px 6px rgba(255, 255, 255, 0.25), inset 3px 3px 6px rgba(0, 0, 0, 0), 3px 3px 6px rgba(0, 0, 0, 0.25), inset -3px -3px 6px rgba(255, 255, 255, 0);
						display: flex;
						justify-content: center;
						align-items: center;
						width: 70%;
						height: 70%;
						transition: box-shadow 0.1s ease-in-out;
						@include noSelect();

					}

					&.disabled {
						pointer-events: none;
						opacity: 0.5;
					}

				}
			}

			&.temporaryDisable {
				pointer-events: none;

				.numpad {
					opacity: 0.5;
				}

				.bottom-row {

					.numpad-screen-container {
						.numpad-screen {
							background-color: var(--color-danger);
						}
					}
				}
			}

		}
	}

}
</style>